import React from "react"
import { graphql, Link, StaticQuery } from "gatsby"

import Img from "gatsby-image"
import AniLink from "gatsby-plugin-transition-link/AniLink"

import BlogLayout from '../components/layout/BlogLayout'
import { SEO } from 'gatsby-theme-seo'

import kebabCase from "lodash/kebabCase"

import { INLINES, BLOCKS, MARKS } from "@contentful/rich-text-types"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import TextScramble from "../components/TextScramble"
import Truncate from "react-truncate"

const Autoria = ({ data }) => {

  const { contentfulAutor } = data
  const { nome, cargo, eMail, avatar, bio } = contentfulAutor
  const { fluid } = avatar
  
  return (
    <>
      <div className="autoria flex w-full flex-wrap justify-center lg:relative">
        <Link to={`/autor/${kebabCase(nome)}/`} className="bg-white hover:bg-criptoOrange-100 rounded rounded-full border border-gray-300 lg:border-none hover:border-criptoOrange-300 w-32 h-32 lg:w-20 lg:h-20 p-1 mr-3 lg:-mb-6 z-40 lg:absolute top-0">
          <Img
            fluid={fluid}
            alt={nome}
            className="w-full h-full rounded rounded-full"
          />
        </Link>
        <div className="lg:pr-6 lg:pt-6 lg:w-full z-10 border-r-0
          lg:border-r-1 lg:absolute top-0 mt-3 lg:mt-16">
          <div className="font-display tracking-wider uppercase text-base">
            {nome}
          </div>
          <div className="capitalize italic tracking-wide font-light text-gray-600 mb-2 -mt-1 text-sm">
            {cargo.nome}           
          </div>
          <div className="font-display tracking-wider uppercase text-sm text-gray-700">Sobre o Autor:</div>
          <div className="font-light font-body tracking-wider text-left text-gray-700 text-sm">
            <div id="excerpt" className="mt-1 mb-3 font-light w-full">
              <Truncate lines={0} >
              {documentToReactComponents(bio.json, {
                renderMark: {
                  [MARKS.BOLD]: text => <span className="font-bold">{text}</span>,
                  [MARKS.ITALIC]: text => <span className="italic]">{text}</span>,
                  [MARKS.UNDERLINE]: text => <span className="underline">{text}</span>,
                  [MARKS.CODE]: text => <span className="font-mono tracking-wider">{text}</span>,
                },
                renderNode: {
                  [BLOCKS.HEADING_1]: (_node, children) => (
                    <h1>{children}</h1>
                  ),
                  [BLOCKS.HEADING_2]: (_node, children) => (
                    <h2>{children}</h2>
                  ),
                  [BLOCKS.HEADING31]: (_node, children) => (
                    <h3>{children}</h3>
                  ),
                  [BLOCKS.HEADING_4]: (_node, children) => (
                    <h4>{children}</h4>
                  ),
                  [BLOCKS.HEADING_5]: (_node, children) => (
                    <h5>{children}</h5>
                  ),
                  [BLOCKS.HEADING_6]: (_node, children) => (
                    <h6>{children}</h6>
                  ),
                  [BLOCKS.PARAGRAPH]: (_node, children) => <p className="w-full lg:whitespace-normal break-all lg:break-words">{children}</p>,
                  [BLOCKS.QUOTE]: (_node, children) => <blockquote>{children}</blockquote>,
                },
              })}
              </Truncate>
            </div>
            <Link className="font-display uppercase text-sm text-criptoBlue-600 hover:text-criptoOrange-600" to={`/autor/${kebabCase(nome)}/`}>Ver mais deste autor</Link>
          </div>
          <div className="font-display tracking-wider text-gray-700 uppercase text-xs mt-2">Entre em contato:</div>
          <div className="font-light tracking-wide text-sm flex flex-col">
            <Link className="text-criptoBlue-600 hover:text-criptoOrange-600" to={`mailto:${kebabCase(eMail)}`}>{eMail}</Link>
            
          </div>
        </div>
      </div>            
        </>
    )
 
}

//class Gallery extends Component {
//  constructor(props) {
//    super(props);
//    this.state = {
//      shareOpen: false,
//      anchorEl: null,
//      lightbox: false,
//      photos: props.photos.map(photo => Object.assign({ srcSet: photo.childImageSharp.fluid.srcSet })),
//    };
//  }
//
//  gotoPrevLightboxImage() {
//    const { photo } = this.state;
//    this.setState({ photo: photo - 1 });
//  }
//
//  gotoNextLightboxImage() {
//    const { photo } = this.state;
//    this.setState({ photo: photo + 1 });
//  }
//
//  openLightbox(photo, event) {
//    event.preventDefault();
//    this.setState({ lightbox: true, photo });
//  }
//
//  closeLightbox() {
//    this.setState({ lightbox: false });
//  }
//
//  render() {
//    const { photos } = this.props;
//    return (
//      <div>
//        <div>
//          {photos.map((photo, i) => (
//            <a href={data} onClick={e => this.openLightbox(i, e)}>
//              <Img key={i} className={classes.spacer} fluid={data} />
//            </a>
//          ))}
//        </div>
//        <Lightbox
//          backdropClosesModal
//          images={this.state.photos}
//          currentImage={this.state.photo}
//          isOpen={this.state.lightbox}
//          onClickPrev={() => this.gotoPrevLightboxImage()}
//          onClickNext={() => this.gotoNextLightboxImage()}
//          onClose={() => this.closeLightbox()}
//        />
//      </div>
//    );
//  }
//}

const PostContent = ({
  data: {
    contentfulBlogPost: {
      body
    }
  }
}) => (
  <>
    {documentToReactComponents(body.json, {
      renderMark: {
        [MARKS.BOLD]: text => <span className="font-bold">{text}</span>,
        [MARKS.ITALIC]: text => <span className="italic">{text}</span>,
        [MARKS.UNDERLINE]: text => <span className="underline">{text}</span>,
        [MARKS.CODE]: text => <span className="font-mono tracking-wider">{text}</span>,
      },
      renderNode: {
        [BLOCKS.HEADING_1]: (_node, children) => (
          <h1 className="text-gray-700">{children}</h1>
        ),
        [BLOCKS.HEADING_2]: (_node, children) => (
          <h2 className="text-gray-700">{children}</h2>
        ),
        [BLOCKS.HEADING31]: (_node, children) => (
          <h3 className="text-gray-600">{children}</h3>
        ),
        [BLOCKS.HEADING_4]: (_node, children) => (
          <h4 className="text-gray-600">{children}</h4>
        ),
        [BLOCKS.HEADING_5]: (_node, children) => (
          <h5 className="text-gray-600">{children}</h5>
        ),
        [BLOCKS.HEADING_6]: (_node, children) => (
          <h6 className="text-gray-600">{children}</h6>
        ),
        [BLOCKS.PARAGRAPH]: (_node, children) => <p className="w-auto break-words">{children}</p>,
        [BLOCKS.QUOTE]: (_node, children) => <blockquote className="lg:w-55/100 lg:float-right">{children}</blockquote>,
        [BLOCKS.EMBEDDED_ASSET]: node => (
          <div className="border-1 border-gray-300 p-2 mr-3 float-left">
            <img 
            src={`${node.data.target.fields.file["pt-BR"].url}?w=300&q=90`}
            alt={node.data.target.fields.title["pt-BR"]}
            />
            <span className="text-gray-600 italic">{node.data.target.fields.title["pt-BR"]}</span>
          </div>
        ),
      },
    })}
  </>
)

export default function Template({ data }) {
  const { contentfulBlogPost, allContentfulCategorias, contentfulAutor } = data
  const { title, id, tags, featuredImage } = contentfulBlogPost
  const { fluid } = featuredImage

  const imgClasses = "absolute w-full top-0 left-0 z-10"

  return (

		<BlogLayout id={id} kind="artigo">
      <SEO title={title} />
      <div className="container mx-auto px-8 lg:px-16">
        <div id="wrapper" className="w-full flex flex-wrap items-start">
        <div 
          className={`
            w-full
            h-1/3 
            md:h-1/2        
            relative 
            z-0 
            order-first 
            -mt-6

          `} 
          postName={title}>
          <Img 
            fluid={!featuredImage ? data.imageSharp.fluid : fluid}  
            className={imgClasses}
            style={{height: 698, backgroundPosition: `center`}}
            alt={title}
          />
          
            
          <h1 
            className={`
              bg-white 
              py-1 
              md:pl-24 
              lg:pl-64 
              px-4 
              w-auto 
              inline-block 
              text-2xl 
              md:text-2xl 
              lg:text-4xl 
              absolute  
              top-full
              -mt-20
              lg:top-1/2 
              lg:mt-64

              z-50
            `}>
            <TextScramble>
              {title}
            </TextScramble> 
          </h1>
        </div>          

        <div className={`
          w-full
          md:w-1/2
          lg:w-1/5

          mx-auto 
          lg:mx-0 
           
          mt-12 
          lg:-mt-10
          pt-6
          lg:pr-3 
          md:pl-8
          lg:pl-0

          text-left

          border-t-1 
          lg:border-t-0
          z-30 
          order-3
          md:order-last 
          lg:order-2
        `} id="autoria">
          <Autoria data={data} />
        </div>
        
        <div className="content-body w-full break-all lg:w-3/5 text-left pt-3 lg:pt-10 px-4 md:px-24 font-body font-light order-2 lg:order-3">
          <PostContent data={data} />
        </div>
         
        <div className="w-full md:w-1/2 lg:w-1/6 mt-12 md:order-3 order-last border-t-1 lg:border-t-0 lg:border-l-1">
          <div className="complementos px-0 md:pr-10 md:mt-40 lg:mt-0 lg:pl-6 py-4" id="meta">
            <div className=" lg:px-0 w-full z-10">
              <div className="categorias">
                <div className="font-display tracking-wider uppercase text-sm">
                  Categorias:
                </div>
                <ul className="mb-4">
                  {allContentfulCategorias.edges.map(({node}, i) => {
                    const {
                      nome,
                      slug
                    } = node 
                    return (
                      <li className={`
                      inline-block 
                      p-1
                      mt-2
                      mr-2
                      rounded 

                      text-sm 
                      font-light
                      capitalize  
                        
                      text-gray-700 
                      hover:text-criptoBlue-700 

                      bg-gray-300 
                      hover:bg-criptoBlue-200                     
                      
                      border-b-2 
                      border-r-2 
                      border-gray-400
                      hover:border-criptoBlue-400
                      
                      hover:shadow-md
                      
                    `}>
                      <AniLink
                        paintDrip
                        duration={1}
                        key={i}
                        to={`/categorias/${slug}/`}>
                          {nome}
                      </AniLink>
                    </li>
                    )
                  })}
                </ul>
                
              </div>
              
              <div className="tags">
                <div className="font-display tracking-wider uppercase text-sm">
                  Tags:
                </div>
              
                <ul className="mb-4">
                  {tags.map(( tag , i ) => (
                    <li className={`
                    inline-block 
                    p-1
                    mt-2
                    mr-2
                    rounded 

                    text-sm 
                    font-light  
                    capitalize
                     
                    text-gray-700 
                    hover:text-criptoBlue-700 

                    bg-gray-300 
                    hover:bg-criptoBlue-200                     
                    
                    border-b-2 
                    border-r-2 
                    border-gray-400
                    hover:border-criptoBlue-400
                    
                    hover:shadow-md
                  `}>
                      <AniLink
                        paintDrip
                        duration={1}
                        key={i}
                        to={`/tags/${kebabCase(tag)}/`}>
                          {tag}
                      </AniLink>
                    </li>
                  ))}
                </ul>
              </div>
                
              </div>

            </div>
          </div>
        </div>

      </div>
        
    </BlogLayout>

  )
}

export const pageQuery = graphql`
  query(
    $slug: String!, 
    $autor: String
  ) {
    contentfulBlogPost(
      slug: { 
        eq: $slug 
      }  
    ) {
      title
      id
      body {
        json
        content {
          data {
            target {
              fields {
                file {
                  pt_BR {
                    url
                  }
                }
                title {
                  pt_BR
                }
              }
            }
          }
        }
      }
      tags
      categoria {
          nome
          slug
        }
      featuredImage {
        fluid(toFormat: WEBP, maxWidth: 1700) {
          ...GatsbyContentfulFluid
        }      
      }
    },
    imageSharp(
      id: {
        eq: "2f858388-303c-53c6-a048-99a0354b7031"
      }
    ) {
      fluid(maxWidth: 1200, toFormat: PNG) {
        ...GatsbyImageSharpFluid
      }
    },
    allContentfulCategorias(
      filter: {
        blog_post: {
          elemMatch: {
            slug: {
              eq: $slug
            }
          }
        }
      }
    ) {
      edges {
        node {
          nome
          slug
        }
      }
    }
    contentfulAutor(
      nome: {
        eq: $autor
      }
    ) {
      bio {
        json
      }
      eMail
      nome
      cargo {
        nome
      }
      avatar {
        fluid {
          ...GatsbyContentfulFluid
        }
      }
    }
  }
`